import {ISidenavService} from '../sidenav/sidenav.types';
import OrganizationApi from '../../api/organization-api.service';
import OrganizationService from '../organization/organization.service';
import {IOrganizationEvents} from '../organization/organization.controller';
import {ILoginService} from '../../auth/login.service';
import {IUserApi} from '../../api/user-api.service';
import { StateService } from 'angular-ui-router';

interface ILanguageCodeTable {
  [index: string]: string;
}

export default class ToolbarController {
  static $inject = ['$state', 'sidenavService', '$translate', 'organizationApi', 'organizationService', '$rootScope', '$location', 'userApi'];

  static readonly LANGUAGE_NAMES: ILanguageCodeTable = {
    'en': 'English',
    'ru': 'Русский'
  };

  private organization: string;
  private currentUser: string;

  constructor(private $state: StateService,
              private sidenavService: ISidenavService,
              private $translate: ng.translate.ITranslateService,
              private organizationApi: OrganizationApi,
              private organizationService: OrganizationService,
              private $rootScope: ng.IRootScopeService,
              private $location: ng.ILocationService,
              private userApi: IUserApi) {

    if (this.$location.path() !== '/reset-password/') {
      this.setCurrentUserName();
      this.setCurrentOrganizationName(); 
    }

    this.$rootScope.$on(IOrganizationEvents.ORGANIZATION_CHANGE, () => {
        this.setCurrentOrganizationName();
    });

    this.$rootScope.$on(ILoginService.LOGOUT_EVENT_NAME, () => {
        this.organization = null;
        this.currentUser = null;
    });

    this.$rootScope.$on(ILoginService.LOGIN_EVENT_NAME, () => {
        this.setCurrentUserName();
        this.setCurrentOrganizationName(); 
    });
  }

  get currentOrg() {
    return this.organization;
  }

  get currentLanguage() {
    return ToolbarController.LANGUAGE_NAMES[this.$translate.use()];
  }

  goToCurrentOrgPage() {
    this.organizationService.getCurrentOrgId()
      .then(id => {
        this.$state.go("organization", { id: id });
      });
  }

  setCurrentOrganizationName() {
    this.organizationService.getCurrentOrgId()
      .then(id => {
        this.organizationApi.getOrganization(id)
          .then(data => {
            this.organization = data.organization;
          });    
      });
  };

  setCurrentUserName() {
    this.userApi.getCurrentUser()
      .then((data) => {
        this.currentUser = data;
      })
  }

  toggleLeftSidenav() {
    this.sidenavService.toggleLeftSidenav();
  }

  selectLanguage(languageKey: string) {
    this.$translate.use(languageKey);
  }
}



/** WEBPACK FOOTER **
 ** ./app/hydromet/toolbar/toolbar.controller.ts
 **/